import { Skeleton } from '../../ui/Skeleton';

/** Zelfde maten als ProductCard, zodat er niets verspringt als de producten binnenkomen. */
export function ProductGridSkeleton({
  count = 6
}: {
  count?: number;
}) {
  return <ul aria-hidden="true" className="grid grid-cols-2 gap-x-4 gap-y-12 sm:gap-x-6 xl:grid-cols-3" data-id="element-8993" data-mp="1aqn60063cx3a">
      {Array.from({
      length: count
    }, (_, i) => <li key={i} className="flex flex-col" data-id="element-8994" data-mp="15t3u36wv8wei">
          <Skeleton className="aspect-[4/5] w-full bg-blush" data-id="element-8995" data-mp="i0wtfvk3y39a" />
          <Skeleton className="mt-4 h-3 w-1/3" data-id="element-8996" data-mp="i39i0rkdfbvb" />
          <Skeleton className="mt-2.5 h-5 w-4/5" data-id="element-8997" data-mp="e0wem9t3jq1p" />
          <Skeleton className="mt-2 h-3.5 w-full" data-id="element-8998" data-mp="e27i08imqvsa" />
          <Skeleton className="mt-1.5 h-3.5 w-2/3" data-id="element-8999" data-mp="s0npi1obgqbh" />
          <span className="mt-4 flex items-center justify-between border-t border-line pt-3.5" data-id="element-9000" data-mp="n0j35v0q91dc">
            <Skeleton className="h-5 w-16" data-id="element-9001" data-mp="23essosgpgw5r" />
          </span>
        </li>)}
    </ul>;
}